<template>
  <div class="application_wrap">
    <!--    주소검색 iframe-->
    <div
        v-show="showPostcodeLayer"
        id="postcode-wrapper"
        style="position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:9999;background:#fff;">
      <button
          @click="showPostcodeLayer = false"
          style="position:absolute;top:10px;right:20px;z-index:10000;font-size:24px;background:transparent;border:none;cursor:pointer;">
        ×
      </button>
      <div style="height:50px;"></div>
      <div id="postcode-iframe" style="width:100%;height:calc(100vh - 50px);"></div>
    </div><!--iframe end-->

    <h3 style="place-self: center; margin: 1rem 1rem 1rem 1rem">서울특별시 시각장애인 플러스 지원센터 이용 신청서</h3>
    <hr>
    <!-- 폼 영역 -->
    <div class="accept_wrap">
      <!-- 이름 입력 -->
      <div class="form-group">
        <label>이름</label>
        <div class="accept_area">
          <input type="text" class="form-control" ref="user_name" v-model.trim="user_name"
                 placeholder="이름을 입력해 주세요."/>
        </div>
      </div>

      <!-- 생년월일 입력 -->
      <div class="form-group">
        <label>생년월일</label>
        <div class="accept_area">
          <select v-model="bir_year" title="년도">
            <option disabled value="">년도</option>
            <option v-for="year in year_list" :value="year" :key="'bir_year_' + year">{{
                year
              }}
            </option>
          </select>
          <select v-model="bir_month" title="월">
            <option disabled value="">월</option>
            <option v-for="month in 12" :value="month" :key="'bir_month_' + month">{{
                month
              }}월
            </option>
          </select>
          <select v-model="bir_day" title="일">
            <option disabled value="">일</option>
            <option v-for="day in 31" :value="day" :key="'bir_day_' + day">{{ day }}일</option>
          </select>
        </div>
      </div>

      <!--      성별 -->
      <div class="form-group">
        <label>성별</label>
        <div class="accept_area">
          <div class="gender_check">
            <label>남<input type="radio" name="gender_option" value="남" v-model="gender"/></label>
            <label>여<input type="radio" name="gender_option" value="여" v-model="gender"/></label>
          </div>
        </div>
      </div>

      <!-- 주소 입력 -->
      <div class="form-group">
        <label>주소</label>
        <div class="accept_area">
          <input type="text" class="form-control" v-model="roadAddress" @keyup.enter="searchAddress"
                 placeholder="도로명주소" readonly/>
          <button type="button" @click="showPostcodeLayer = true">주소 검색</button>
          <br/>
          <input type="text" class="form-control" v-model="detailAddress" placeholder="상세주소"/>
          <input type="hidden" v-model.trim="addr"/>
        </div>
      </div>

      <!-- 장애 등급 -->
      <div class="form-group">
        <label>장애등급</label>
        <div class="accept_area">
          <input type="text" class="form-control" v-model.trim="grade" value="신장" readonly/>
        </div>
      </div>

      <!-- 휴대폰번호 입력 -->
      <div class="form-group">
        <label>휴대폰번호</label>
        <div class="accept_area">
          <input type="text" class="form-control" v-model.trim="mobile"
                 placeholder="휴대폰번호를 입력해 주세요."/>
          <button type="button" @click="checkDuplicatedPhone">중복 체크</button>
          <br/>
          <div v-if="showCertificationSection">
            <input type="text" class="form-control" v-model="certificationNumber"
                   placeholder="인증번호를 입력해 주세요."/>
            <button type="button" @click="checkCertificationNumber">확인</button>
          </div>
        </div>
      </div>

      <!-- 알림매체 -->
      <div class="form-group">
        <label>알림 매체</label>
        <div class="accept_area">
          <div class="gender_check">
            <label>문자<input type="radio" name="notify_type" value="S" checked/></label>
            <label>알림톡<input type="radio" name="notify_type" value="K"/></label>
          </div>
        </div>
      </div>

      <!-- 첨부 파일 -->
      <div class="form-group">
        <label>첨부파일</label>
        <div class="accept_area">
          <div class="input-file-wrap">
            <div class="input-file-row">
              <button type="button" @click="triggerFileInput(1)">파일 선택</button>
              <span class="filename" v-if="file_1_name">{{ file_1_name }}</span>
              <input
                  type="file"
                  ref="fileInput1"
                  accept="image/*"
                  style="position:absolute; left:-9999px; width:1px; height:1px; opacity:0;"
                  @change="handleFileUpload(1, $event)"
              >
            </div>
            <div class="input-file-row">
              <button type="button" @click="triggerFileInput(2)">파일 선택</button>
              <span class="filename" v-if="file_2_name">{{ file_2_name }}</span>
              <input
                  type="file"
                  ref="fileInput2"
                  accept="image/*"
                  style="position:absolute; left:-9999px; width:1px; height:1px; opacity:0;"
                  @change="handleFileUpload(2, $event)"
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 복지카드 -->
      <div class="form-group">
        <label>복지카드 유효기간</label>
        <div class="accept_area">
          <input type="text" class="form-control" v-model.trim="walfare_expiration"
                 placeholder="복지카드 유효기간을 입력해 주세요."/>
          <span
              style="width:100%">예시: 1991년 10월 03일 → 911003 <br> 복지카드 유효기간이 없는 경우 빈칸으로 입력해주세요.</span>
        </div>
      </div>
    </div>

    <!-- 동의 확인 영역 -->
    <div class="application_agree">
      <p>상기 본인은 서울특별시 시각장애인 플러스 지원센터 이용을 희망하여 첨부 서류와 함께 이용 등록을 신청합니다. </p>
      <div class="agree_check">
        <label for="check1">신청서 동의 확인</label>
        <input type="checkbox" v-model="agree_1" id="check1"/>
      </div>

      <p>서울시각장애인생활지원센터는 교통약자의 [이동편의증진법] 제4조(국가의 책무) 및 [개인정보보호법] 제15조(개인정보의 수집·이용),
        [신용정보의 이용 및 보호에 관한 법률] 제15조(수집·조사 및 처리의 원칙)에 의거하여 개인정보를 수집합니다.
      </p>
      <p class="agree_spread">개인정보수집항목과 이용목적 이용기간 거부 시 안내
        <button @click="toggleNotice">{{ btnName }}</button>
      </p>
      <p class="agree_list" id="agree_list1" v-if="toggle">
        <b>■ 개인정보 수집 항목</b><br>
        ㅇ 개인정보 : 성명, 성별, 생년월일, 주소, 휴대폰번호, 전화번호, 장애인(유형,등급)등록정보, 기타 생활 지원 대상자 선정을 위한 정보<br>
        <br>
        <b>■ 개인정보 수집 및 이용목적</b><br>
        ㅇ 서울시각장애인생활지원센터 차량의 이용요금 정산 및 만족도조사 업무 수행에 활용<br>
        ㅇ 장애인 이용 서비스 생활지원센터 제도 관련 본인 확인절차<br>
        ㅇ 이용접수 업무 및 콜 처리에 수행 및 우편물·휴대전화 문자메시지 발송<br>
        ㅇ 기타 생활지원센터 제도 운영에 필요한 자료로 활용<br>
        <br>
        <b>■ 개인정보 보유 및 이용기간</b><br>
        ㅇ 상기 개인정보는 생활지원센터 사업기간(준영구) 동안 보유 및 이용됩니다.<br>
        ㅇ 상기 개인정보의 이용 목적이 소멸된 경우에도 사회서비스 바우처 택시 제도 운영 등 이용목적이 분명한 경우는 개인 정보를
        보유할 수 있음을 안내하여 드립니다.<br>
        <br>
        <b>■ 동의를 거부할 권리 및 거부 시 불이익</b><br>
        ㅇ 상기 내용은 장애인이용 서비스 생활지원 업무와 지원을 위해 필요한 최소한의 정보에 해당하며,
        그 내용에 관하여 개인정보 제공 동의를 거부할 권리가 있으며, 동의 거부에 따른 불이익은 없습니다.
        다만, 생활지원센터 차량 이용 제도의 이용이 제한될 수 있음을 알려드립니다.<br>
      </p>

      <p class="agree_list"><b>■ 개인정보 수집 및 이용에 관한 동의</b><br> “개인정보 보호법”에 명기된 관련 법률에 의거, 개인정보 수집 및
        이용에 동의하십니까?</p>
      <div class="agree_check">
        <label for="check4">동의함</label>
        <input type="radio" v-model="agree_4" name="agree4" value="1"/>
        <span><label for="check4_no">동의하지 않음</label>
                <input type="radio" v-model="agree_4" name="agree4" value="0"/></span>
      </div>

      <p class="agree_list"><b>■ 서울 시각장애인 생활지원센터 복지콜 이용규칙 동의</b><br> 이용자의 편리한 이용과 서비스 운영을 위한 서울시각장애인
        생활지원센터 복지콜 이용규칙에 동의하시겠습니까?
        <a href="https://kbucall.org/m/sub/10" target="_blank"
           style="border:solid 1px; background-color:#444444; color:white;">자세한 이용규칙 보기</a>
      </p>
      <div class="agree_check">
        <label for="check5">동의함</label>
        <input type="radio" v-model="agree_5" name="check5" value="1"/>
        <span><label for="check2_no">동의하지 않음</label>
                <input type="radio" v-model="agree_5" name="check5" value="0"/></span>
      </div>

      <p class="agree_list"><b>■ 블랙박스 운영에 관한 동의</b><br> 운행의 안전과 사고로부터 이용자와 운전자를 보호하는 블랙박스를 운영하여 운행하는
        것에 동의 하시겠습니까?</p>
      <div class="agree_check">
        <label for="check2">동의함</label>
        <input type="radio" v-model="agree_2" name="agree2" value="1"/>
        <span><label for="check2_no">동의하지 않음</label>
                <input type="radio" v-model="agree_2" name="agree2" value="0"/></span>
      </div>

      <!-- 개인정보 제3자 제공 동의 -->
      <p class="agree_list">
        <b>■ 개인정보의 목적 외 이용 또는 제3자 제공에 관한 동의</b><br>
        서울시각장애인생활지원센터는 장애인 이동 서비스 제공을 위하여 수집한 개인정보를 아래의 내용과 같이 제3자에게 제공하고 있습니다.<br>
        ① 서울특별시 · 자치구<br>
        - 생활지원센터 운영 제도 시행에 필요한 지방자치단체의 예산 배정 및 관리를 위한 정보제공 <br>
        - 이용자선정을 위한 심사자료 조회 및 이용자격 확인을 위한 정보제공<br>
        ② 한국스마트카드(T머니)<br>
        - 생활지원센터 수행기관 간 이용자 정보 전송을 위한 정보제공 <br>
        ③ 통계조사업체<br>
        - 생활지원센터 이용 대상자 통계 조사를 위한 대상자 정보(기본정보 및 휴대폰번호 정보)제공<br>
        <p>※ 목적 외 이용 및 제3자 제공에 동의하십니까?</p>
        <p class="agree_check">
          <label for="check3">동의함</label>
          <input type="radio" v-model="agree_3" name="agree3" value="1"/>
          <span><label for="check3_no">동의하지 않음</label>
                <input type="radio" v-model="agree_3" name="agree3" value="0"/></span>
        </p>
      </p>

      <p>
        개인정보 보호법에 명기된 법률상의 개인정보처리자가 준수하여야 할 개인정보보호 규정을 준수하며, 관련법령에 의거하여 제공인력의 권익보호에 최선을 다하고 있으며 동의한
        이용 목적 외에는 사용하지 않을 것을 약속 드립니다.
      </p>

      <!-- 날짜 표시 -->
      <div class="agree_date"><span>{{ yyyy }}</span>년<span> {{ mm }}</span>월<span> {{ dd }}</span>일
      </div>
    </div>

    <!-- 신청 버튼 -->
    <div class="btn_bottom">
      <button class="btn_common" @click="regist">신청서 접수하기</button>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      toggle: false,
      btnName: "펼치기",

      showPostcodeLayer: false, // 주소검색 iframe visibility

      user_name: "",
      bir_year: "",
      bir_month: "",
      bir_day: "",
      gender: "",
      roadAddress: "",
      detailAddress: "",
      addr: "",
      grade: "신장", // 기본으로 '신장'
      mobile: "",
      notify_type: "S",
      file_1: null,
      file_1_name: "파일명",
      file_2: null,
      file_2_name: "파일명",
      walfare_expiration: "",
      agree_1: false,
      agree_2: null,
      agree_3: null,
      agree_4: null,
      agree_5: null,
      showCertificationSection: false,
      certificationNumber: "",
      showCountdownSection: false,
      countdown: 180,
      year_list: this.generateYearList(),
      verificationNumber: this.generateFiveDigitRandomNumber(),

      yyyy: new Date().getFullYear(), // 현재 연도
      mm: ('0' + (new Date().getMonth() + 1)).slice(-2), // 현재 월 (2자리로 포맷)
      dd: ('0' + new Date().getDate()).slice(-2) // 현재 일 (2자리로 포맷)
    };
  },

  watch: {
    showPostcodeLayer(val) {
      if (val) {
        this.searchAddress();
      }
    }
  },

  methods: {
    // 년도별 리스트 생성
    generateYearList() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear; i >= 1920; i--) {
        years.push(i);
      }
      return years;
    },

    // 주소 검색
    searchAddress() {
      new daum.Postcode({
        oncomplete: (data) => {
          // 도로명 주소의 노출 규칙에 따라 주소를 표시
          let roadAddr = data.roadAddress; // 도로명 주소 변수
          let extraRoadAddr = ''; // 참고 항목 변수

          // 법정동명이나 공동주택 추가 정보
          if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
            extraRoadAddr += data.bname;
          }
          if (data.buildingName !== '' && data.apartment === 'Y') {
            extraRoadAddr += extraRoadAddr !== '' ? ', ' + data.buildingName : data.buildingName;
          }
          if (extraRoadAddr !== '') {
            extraRoadAddr = ' (' + extraRoadAddr + ')';
          }

          // 선택한 도로명 주소를 roadAddress에 설정
          this.roadAddress = roadAddr;

          this.showPostcodeLayer = false;
        },
        width: '100%',
        height: '100%'
      }).embed(document.getElementById("postcode-iframe"));
    },

    // 파일 업로드 핸들링
    triggerFileInput(idx) {
      if (idx === 1) {
        this.$refs.fileInput1.click();
      } else if (idx === 2) {
        this.$refs.fileInput2.click();
      }
    },
    handleFileUpload(fileIndex, event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      if (!['image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
        alert("이미지 파일만 업로드 가능합니다.");
        return;
      }
      if (fileIndex === 1) {
        this.file_1 = file;
        this.file_1_name = file.name;
      } else if (fileIndex === 2) {
        this.file_2 = file;
        this.file_2_name = file.name;
      }
    },

    // 인증번호 생성 및 전송
    makeIdentityNumber() {
      // 휴대폰, 이름, 생일 유효성 검사
      if (this.isNameValidation || this.isBirthDayValidation || this.isPhoneValidation) {
        this.authWarning = true;  // Vue 데이터 바인딩으로 처리 (authWarning 상태 토글)
        return;
      }

      this.authWarning = false;  // 경고 숨기기
      this.showCertificationSection = true;  // 인증 섹션 표시
      this.showCountdownSection = true;      // 카운트다운 섹션 표시

      // 날짜 생성
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      const dtformat = year + month + day + hours + minutes;

      // 인증번호 생성
      this.verificationNumber = this.generateFiveDigitRandomNumber(); // Vue 메서드로 인증번호 생성

      // 메시지 내용 설정
      const receive_msg = `[서울시각] 인증번호를 입력해주세요. [${this.verificationNumber}]`;

      // 전송할 데이터 구조
      const data = {
        dtformat: dtformat,
        phone: this.mobile,  // Vue 데이터에서 가져옴
        verificationNumber: receive_msg,
      };

      // POST 요청
      this.$http.post('/api/send.do', data, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      }).then((response) => {
        console.log(response);
        if (response.data.data === "OK") {
          alert("인증번호 전송 완료")
        } else {
          alert("인증번호 전송을 실패했습니다.");
        }
      }).catch((error) => {
        console.error(error);
        alert("인증번호 전송 중 오류 발생. 다시 시도해주세요.");
      });
    },

    // 임의 5자리 인증번호 생성
    generateFiveDigitRandomNumber() {
      return Math.floor(10000 + Math.random() * 90000);
    },

    // 휴대폰 중복 체크
    checkDuplicatedPhone() {
      const phone = this.mobile.replace(/-/g, '');
      if (!/^(01[016789])(\d{3,4})(\d{4})$/.test(phone)) {
        alert("올바른 휴대폰 번호를 입력해주세요.");
        return;
      }
      this.$http.post('/api/checkDuplicatedPhone.do', {phone})
      .then((response) => {
        if (response.data.retval === 0) {
          alert("이미 가입된 전화번호입니다.");
        } else {
          alert("중복 체크 완료. 인증번호를 입력해주세요.");
          this.makeIdentityNumber();
          this.showCertificationSection = true;
        }
      })
      .catch((error) => {
        alert("중복 체크에 실패했습니다. 다시 시도해주세요.");
        console.error(error);
      });
    },

    // 인증번호 확인
    checkCertificationNumber() {
      if (this.certificationNumber !== String(this.verificationNumber)) {
        alert("인증번호를 다시 확인해주세요.");
      } else {
        alert("본인 인증 성공!");
        this.showCertificationSection = false;
      }
    },

    // 신청서 제출
    regist() {
      console.log(this.agree_1, this.agree_2, this.agree_3)
      this.addr = this.roadAddress + " " + this.detailAddress;
      // 필수 항목을 확인하는 모든 유효성 검사
      if (!this.user_name) {
        alert("이름을 입력해주세요.");
        return;
      }
      if (!this.bir_year || !this.bir_month || !this.bir_day) {
        alert("생년월일을 정확히 입력해주세요.");
        return;
      }
      if (!this.gender) {
        alert("성별을 선택해주세요.");
        return;
      }
      if (!this.addr) {
        alert("주소를 입력해주세요.");
        return;
      }
      if (!this.mobile) {
        alert("휴대폰번호를 입력해주세요.");
        return;
      }
      if (!this.agree_1 || this.agree_2 !== '1' || this.agree_3 !== '1') {
        alert("모든 동의 항목을 확인해주세요.");
        return;
      }

      const formData = new FormData();
      formData.append('user_name', this.user_name);
      formData.append('bir_year', this.bir_year);
      formData.append('bir_month', this.bir_month);
      formData.append('bir_day', this.bir_day);
      formData.append('gender_option', this.gender);
      formData.append('addr', this.addr);
      formData.append('mobile', this.mobile);
      formData.append('notify_type', this.notify_type)
      formData.append('walfare_expiration', this.walfare_expiration);
      formData.append('grade', this.grade);
      if (this.file_1) {
        formData.append('file_1', this.file_1);
      }
      if (this.file_2) {
        formData.append('file_2', this.file_2);
      }

      // for (let pair of formData.entries()) {
      //   console.log(pair[0]+ ': ' + pair[1]);
      // }

      this.$http.post('/api/registAction.do', formData)
      .then((response) => {
        console.log(response);
        if (response.data.retval === this.CONSTANT.SUCCESS) {
          alert("신청이 완료되었습니다. 관리자 승인 후 문자가 발송됩니다.");
          this.$router.push('/m')
        } else {
          alert("신청 실패. 다시 시도해주세요.");
        }
      })
      .catch((error) => {
        alert("신청 실패. 다시 시도해주세요.");
        console.error(error);  // 에러 로그를 출력함.
      });
    },
    toggleNotice() {
      this.toggle = !this.toggle;
      if (this.toggle) {
        this.btnName = "접기";
      } else {
        this.btnName = "펼치기";
      }
    }
  } // method end
};
</script>
<style>
.agree_check {
  place-self: center;
  font-weight: bold;
  margin-bottom: 1rem;
}

.agree_date {
  place-self: center;
}

.application_wrap select {
  width: 31%;
}

.gender_check label {
  width: auto !important;
}

.agree_list {
  border: 1px solid black;
}

.application_wrap .form-group label {
  text-align-last: center !important;
}

.application_wrap .form-group button {
  margin: 10px 0 10px 0;
  padding: 3px 10px;
  border: 1px solid #aaa;
  border-radius: 5px;
  background: #f7f7f7;
}

.application_wrap .accept_wrap {
  margin-left: 0;
  margin-right: 0;
}

.input-file-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-file-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filename {
  font-size: 14px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/pages/member/Regist.vue